import { getText } from "oolib";

// Extract display text from an item (handles both display and main.title formats)
export const getDisplayText = (item) =>
  getText(item?.display) ?? getText(item?.main?.title) ?? "";

// Extract parent reference data for backend rollup resolution
export const getParentData = (option) => {
  const theme = option.tags?.themes?.data?.[0];
  const subTheme = option.tags?.subThemes?.data?.[0];

  return {
    ...(theme && {
      parentThemeId: theme._id,
      parentThemeDisplay: getDisplayText(theme),
    }),
    ...(subTheme && {
      parentSubThemeId: subTheme._id,
      parentSubThemeDisplay: getDisplayText(subTheme),
    }),
  };
};
